import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/Cupons/Criar/Back";
import Formulario from "../../../../components/Admin/Cupons/Criar/Formulario";
import { getUSER } from "../../../../services/auth";

const BlogColunistas = props => {
  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Criar Cupom</h2>
        <Divider />
        <Segment>
          <Formulario />
        </Segment>
      </SemanticContainer>
    </div>
  );
};

export default withRouter(BlogColunistas);
